import React, { useState, useEffect, useRef } from 'react';



function ABRadioAddress(props) {

    const [checked, setChecked] = React.useState(false);

    const { label, name, id, fieldId, isRequired, errId, caseId, divClass, value, caseCheckId, checkDetailsIndex, fieldName,isDisabled=false} = props;

    //alert(value);

    const handleChange = (e) => {
        let name = `selectedOption_${e.target.name}`;
        setChecked({
            [name]: e.target.value
        });

        let value = '';

        if (e.target.value == "Yes") {
            value = 'india'
        } else {
            value = 'outside'
        }



        //  props.inputText({ "name": name, "value": selectedOption.value, "fieldId": fieldId, "isRequired": isRequired, "err_id": `err-${fieldId}` });

        props.inputText([{ "name": name, "value": value, "fieldId": fieldId, "isRequired": isRequired, "err_id": errId, "checkdetailsindex": checkDetailsIndex, "fieldname": fieldName, caseCheckId  }]);

    };

    //Handling Initial States Floating Labels
    const [formData, setFormData] = useState({
        [name]: null,
    });

    useEffect(() => {

      

        if (value != "") {

            let name = `selectedOption_add_${caseCheckId}`;
            setChecked({
                [name]: value == "india" ? "Yes" : "No"
            });
        }

        // setFormData((prevState) => ({
        //     ...prevState,
        //     [name]: value,
        // }));

    }, [value,id]);

    //Handling Floating Labels
    // const handleFloatingLabels = (e) => {

    //     setFormData((prevState) => ({
    //         ...prevState,
    //         [e.target.name]: e.target.value,
    //     }));

    //     props.inputText([{ "name": name, "value": e.target.value, "fieldId": fieldId, "isRequired": isRequired, "err_id": errId, "caseId": caseId, "caseCheckId": caseCheckId }]);


    // }


    // const handleChange = (selectedOption) => {

    //   props.inputText({ "name": name, "value": selectedOption.value, "fieldId": fieldId, "isRequired": isRequired, "err_id": `err-${fieldId}` });

    //   //setKeyword(selectedOption.name);

    // };

    let elementClass = 'col-sm-4 col-md-12 col-xl-4';
    if (divClass) {
        elementClass = divClass;
    }

    return (
        <>

            <div className="col-sm-4 col-md-12 col-xl-4">
                <div className="form-group">
                    <label className="fnt-smi-bld d-block w-100 mt-1">
                        Is this address in India{isRequired == 1 && <sup className="text-danger">*</sup>}
                    </label>

                    <div className="form-check form-check-inline mr-4">
                        <input
                            type="radio"
                            className="form-check-input"
                            // name="addressYesNo"
                            id={`add_${caseCheckId}_yes`}
                            value="Yes"
                            // checked="true"
                            name={`add_${caseCheckId}`}
                            checked={checked['selectedOption_add_' + caseCheckId] === "Yes"}
                            onChange={handleChange}
                            disabled={isDisabled}
                        />
                        <label
                            htmlFor={`add_${caseCheckId}_yes`}
                            className="form-check-label"
                        >
                            Yes
                        </label>
                    </div>

                    <div className="form-check form-check-inline">
                        <input
                            type="radio"
                            className="form-check-input"
                            // name="addressYesNo"
                            id={`add_${caseCheckId}_no`}
                            value="No"
                            name={`add_${caseCheckId}`}
                            checked={checked['selectedOption_add_' + caseCheckId] === "No"}
                            onChange={handleChange}
                            disabled={isDisabled}
                        />
                        <label
                            htmlFor={`add_${caseCheckId}_no`}
                            className="form-check-label"
                        >
                            No
                        </label>
                    </div>
                    <p className="err text-danger" id={errId}></p>  
                </div>
            </div>



        </>
    );
}

export default ABRadioAddress;
